<template>
  <div class="alert-number-card">
    <i
      v-if="level"
      class="icon-alert-filled warning-icon"
      :class="$_getColorByLevel(level)"
    />
    <i
      v-if="icon"
      class="icon-start"
      :class="icon"
    />
    <p class="card-title">
      {{ $t(title) }}
    </p>
    <WsLoading v-if="isLoading" primary class="mt-8"/>
    <p v-else class="num">
      {{ number ? number : 0 }}<span v-if="type === 'percent'&&number">%</span>
    </p>
  </div>
</template>
<script>
export default {
  name: "AlertNumberCard",
  props: {
    title: {
      type: String,
      default: "",
    },
    number: {
      type: [Number, String],
      default: 0,
    },
    type: {
      type: String,
      default: "",
    },
    level: {
      type: Number,
      default: 0,
    },
    icon: {
      type: String,
    },
    isLoading: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    $_getColorByLevel(level) {
      if (!level) return;
      if (level === 1) {
        return "yellow";
      } else if (level === 2) {
        return "red";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.alert-number-card {
  @include flex_align;
  flex-direction: column;
  justify-content: center;
  position: relative;
  overflow: hidden;
  height: 116px;
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 1.17;
  letter-spacing: 0.6px;
  color: var(--gray-900);
  border-radius: 20px;
  background-color: var(--white);
  .card-title {
    font-size: 0.875rem;
    font-weight: bold;
    line-height: 1.43;
    letter-spacing: 1px;
    color: var(--gray-900);
  }
  .num {
    @include auto_margin_top(8px);
    font-size: 1.5rem;
    line-height: 1.17;
    letter-spacing: 0.6px;
  }
  .warning-icon {
    position: absolute;
    top: 40px;
    left: 20px;
    font-size: 2.25rem;
    &.red {
      color: var(--red-500);
    }
    &.yellow {
      color: #ffd500;
    }
  }
  .icon-start {
    position: absolute;
    top: 40px;
    left: 20px;
    font-size: 2.25rem;
    color: var(--gray-700);
  }
}
</style>